import { createLazyFileRoute } from "@tanstack/react-router";

import { PanelsPage } from "@/features/admin/routes/Panels";

export const Route = createLazyFileRoute("/_auth/admin/panels/")({
  component: PanelsPage,
});
